(ns ui.data.tenant.event
  (:require [re-frame.core :as rf]
            [ui.data.tenant.sub :as sub]))

(rf/reg-event-fx
 ::update-tenant
 (fn [{db :db} [_ tenant]]
   {:db (-> db
            (assoc ::sub/tenant tenant))}))
